export enum UserRoleEnum {
    SUPER_ADMIN = 'sa',
    ADMIN =     'adm',
    ATTENDANT = 'att',
    MEMBER =    'mem'
}
